<script>
    export let fill = '#FFF'
</script>

<style>
    svg {
        position: absolute;
        top: 0;
        left: 1px;
    }
</style>

<svg id='schedule-navbar' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1170 269.92">
    <g id="Layer_2" data-name="Layer 2">
        <g id="topbar">
            <rect {fill} id="topbar-2" data-name="topbar" width="1170" height="269.92"/>
        </g>
    </g>
</svg>